<template>
  <div class="filter-mobile">
    <div class="filter-mobile__label display-flex-wrap justify-content-between" :class="{'layout-2': !dataBookGroup || dataBookGroup.length === 0}">
        <div
          class="item item--subject btn btn-gray border-rd-20 display-flex-center justify-content-center"
          :class="{'active': selectBoxOpen === 'subject'}"
          @click="handleCollapseSelect('subject')"
        >
          <span
            class="item__name font-sanpro-semibold font-size-16"
            :class="{'primary-color': selectBoxOpen === 'subject', 'secondary-color-txt': selectBoxOpen !== 'subject'}"
          >
            Môn học
          </span>
          <span class="item__icon">
            <i
              class="icon-arrow-down font-size-12"
              :class="{'primary-color': selectBoxOpen === 'subject', 'secondary-color-txt': selectBoxOpen !== 'subject'}"
            ></i>
          </span>
        </div>
        <div
          v-if="dataBookGroup && dataBookGroup.length > 0"
          class="item item--group btn btn-gray border-rd-20 display-flex-center justify-content-center"
          :class="{'active': selectBoxOpen === 'group'}"
          @click="handleCollapseSelect('group')"
        >
          <span
            class="item__name font-sanpro-semibold font-size-16"
            :class="{'primary-color': selectBoxOpen === 'group', 'secondary-color-txt': selectBoxOpen !== 'group'}"
          >
            Bộ sách
          </span>
          <span class="item__icon">
            <i
              class="icon-arrow-down font-size-12"
              :class="{'primary-color': selectBoxOpen === 'group', 'secondary-color-txt': selectBoxOpen !== 'group'}"
            ></i>
          </span>
        </div>
        <div
          class="item item--from btn btn-gray border-rd-20 display-flex-center justify-content-center"
          :class="{'active': selectBoxOpen === 'from'}"
          @click="handleCollapseSelect('from')"
        >
          <span
            class="item__name font-sanpro-semibold font-size-16"
            :class="{'primary-color': selectBoxOpen === 'from', 'secondary-color-txt': selectBoxOpen !== 'from'}"
          >
            Nguồn
          </span>
          <span class="item__icon">
            <i
              class="icon-arrow-down font-size-12"
              :class="{'primary-color': selectBoxOpen === 'from', 'secondary-color-txt': selectBoxOpen !== 'from'}"
            ></i>
          </span>
        </div>
    </div>
    <div class="filter-mobile__body">
      <div v-if="selectBoxOpen === 'group'" class="filter-mobile__group display-flex-wrap justify-content-between">
        <a
          v-for="(item, index) of dataBookGroup"
          :key="index"
          href="javascript:;"
          class="item btn btn-gray border-rd-20 font-sanpro-semibold font-size-15"
          :class="handleCheckActiveGroup(item)"
          @click="handleChangeFilterKey('bookGroupId', item.bookGroupId)"
        >
          {{ item.name }}
        </a>
      </div>
      <div v-else-if="selectBoxOpen === 'subject'" class="filter-mobile__subject display-flex-wrap justify-content-between">
        <a
          v-for="(item, index) of dataSubject"
          :key="index"
          href="javascript:;"
          class="item btn btn-gray border-rd-20 font-sanpro-semibold font-size-15"
          :class="handleCheckActiveSubject(item)"
          @click="handleChangeFilterKey('subjectId', item.subjectId)"
        >
          {{ item.name }}
        </a>
      </div>
      <div v-else-if="selectBoxOpen === 'from'" class="filter-mobile__group display-flex-wrap justify-content-between">
        <a
          v-for="(item, index) of dataLinkTypes"
          :key="index"
          href="javascript:;"
          class="item btn btn-gray border-rd-20 font-sanpro-semibold font-size-15"
          :class="handleCheckActiveLinkType(item)"
          @click="handleChangeFilterKey('pagelinkTypeId', item.pageLinkGroupId)"
        >
          {{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY, TAB_MEDIA_PAGE_LINK, TAB_LESSON, ID_MODAL_READ_LINK_TYPE } from './../../_store/constants'
import { getAllTypeFilter } from './../../_api/'

export default {
  name: 'FilterCollapseMobile',
  props: {
    chooseLabel: String
  },
  data() {
    return {
      dataSubject: [],
      dataBookGroup: [],
      dataLinkTypes: [],
      typePagelinks: TAB_MEDIA_PAGE_LINK,
      typeLesson: TAB_LESSON,
      selectBoxOpen: '', // class, group
      classItemActive: 'active primary-color',
      classItemNormal: 'secondary-color-txt'
    };
  },
  computed: {
    ...mapState(STORE_KEY, ['paramSearchLessons', 'paramFilterBook', 'paramFilterBookLesson']),
    classId () {
      return parseInt(this.$route.query.lop)
    },
    tabActive () {
      return parseInt(this.$route.query.tab) || 0
    },
    routerQuery() {
      return this.$route.query
    },
  },
  watch: {
    'paramSearchLessons.classId': 'getTypesFilter',
    'paramSearchLessons.filterType': 'getTypesFilter',
    chooseLabel (newVal) {
      if (newVal) {
        this.selectBoxOpen = ''
      }
    }
  },
  mounted () {
    this.getTypesFilter(true)
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetParamFilterBook', 'acGetBookOfPageLinks', 'acGetBookOfLessons', 'acSetParamFilterBookLesson', 'acResetBookFilterLib', 'setParamSearchLesson']),

    getTypesFilter (isMounted = false) {
      let self = this
      let params = {
        classId: self.$route.query.lop ? parseInt(self.$route.query.lop) : self.paramSearchLessons.classId,
        filterType: self.paramSearchLessons.filterType
      }
      params.classId !== 0 && getAllTypeFilter(params).then(res => {
        if (res && res.data && !res.errors) {
          self.dataBookGroup = res.data.ltsBookType
          self.dataSubject = res.data.ltsSubject
          self.dataLinkTypes = res.data.ltsPagelinktype
          isMounted && self.setValueFilterCurr()
        }
      })
    },

    async setValueFilterCurr () {
      if ((this.$route.query.mon && this.$route.query.mon !== '0') || (this.$route.query.nhom && this.$route.query.nhom !== '0') ) {
        let tabActive = this.$route.query.tab
        let classActive = this.$route.query.lop && this.$route.query.lop !== '0' ? parseInt(this.$route.query.lop) : 0
        let subjectActive = this.$route.query.mon && this.$route.query.mon !== '0' ? parseInt(this.$route.query.mon) : 0
        let groupActive = this.$route.query.nhom && this.$route.query.nhom !== '0' ? parseInt(this.$route.query.nhom) : 0

        if (tabActive && parseInt(tabActive) === this.typeLesson) {
          await this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, classId: classActive, subjectId: subjectActive, bookGroupId: groupActive})
        } else {
          await this.acSetParamFilterBook({...this.paramFilterBook, classId: classActive, subjectId: subjectActive, bookGroupId: groupActive})
        }
        this.handleFilterBook(true)
        // this.$root.$emit('bv::toggle::collapse', 'collapse_filter')
      }
    },

    handleChangeFilterKey (keyName, data) {
      let self = this
      let key = keyName;
      let value = parseInt(data);
      let tabActive = this.$route.query.tab ? parseInt(this.$route.query.tab) : 1
      if(tabActive === TAB_MEDIA_PAGE_LINK) {
        self.acSetParamFilterBook({...self.paramFilterBook, [key]: value})
      } else {
        self.acSetParamFilterBookLesson({...self.paramFilterBookLesson, [key]: value})
      }
      this.handleFilterBook()
    },

    async handleFilterBook (isMounted = false) {
      let tabActive = this.$route.query.tab
      // Mounted component  has log filter book
      let mountedHasLogFilterBook = this.$route.query.bookf ? parseInt(this.$route.query.bookf) : 0
      if((isMounted && tabActive && parseInt(tabActive) === TAB_MEDIA_PAGE_LINK) || (!isMounted && this.paramSearchLessons.filterType === TAB_MEDIA_PAGE_LINK)) {
        !isMounted && this.acSetParamFilterBook({...this.paramFilterBook, classId: this.paramSearchLessons.classId, pageIndex: 1})
        const { subjectId, bookGroupId, pagelinkTypeId } = this.paramFilterBook
        this.setParamSearchLesson({...this.paramSearchLessons, subjectId, bookGroupId, pagelinkTypeId, pageIndex: 1 })
        this.acGetBookOfPageLinks(this.paramFilterBook)
      } else {
        !isMounted && this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, classId: this.paramSearchLessons.classId, pageIndex: 1})
        const { subjectId, bookGroupId, lessonGroupId } = this.paramFilterBookLesson
        this.setParamSearchLesson({...this.paramSearchLessons, subjectId, bookGroupId, lessonGroupId, pagelinkTypeId: 0, pageIndex: 1 })
        this.acGetBookOfLessons(this.paramFilterBookLesson)
      }
      // this.$root.$emit('bv::toggle::collapse', 'collapse_filter');
      this.$emit('search', this.paramSearchLessons.filterType)
    },

    handleCollapseSelect (type) {
      this.selectBoxOpen = this.selectBoxOpen === type ? '' : type
      this.$emit('changeSelectBox', '')
    },

    handleCheckActiveGroup (data) {
      if (this.paramSearchLessons.filterType === this.typePagelinks) {
        return this.paramFilterBook.bookGroupId == data.bookGroupId ? this.classItemActive : this.classItemNormal
      } else {
        return this.paramFilterBookLesson.bookGroupId === data.bookGroupId ? this.classItemActive : this.classItemNormal
      }
    },

    handleCheckActiveSubject (data) {
      if (this.paramSearchLessons.filterType === this.typePagelinks) {
        return this.paramFilterBook.subjectId === data.subjectId ? this.classItemActive : this.classItemNormal
      } else {
        return this.paramFilterBookLesson.subjectId === data.subjectId ? this.classItemActive : this.classItemNormal
      }
    },

    handleCheckActiveLinkType (data) {
      if (this.paramSearchLessons.filterType === this.typePagelinks) {
        return this.paramFilterBook.pagelinkTypeId === data.pageLinkGroupId ? this.classItemActive : this.classItemNormal
      } else {
        return this.paramFilterBookLesson.pagelinkTypeId === data.pageLinkGroupId ? this.classItemActive : this.classItemNormal
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-mobile {
  &__label {
    .item {
      margin-bottom: 10px;
      width: 32%;
    }

    &.layout-2 {
      .item {
        width: 49%;
      }
    }
  }

  &__subject {
    .item {
      width: 49%;
    }
  }
}
</style>
